import React from 'react';
import { Box, MenuItem, Select } from '@mui/material';
import { PRES, TYPE } from '../chrome';
import { SlideObject, resolveSlideFontFamily } from '../types';
import { matchTextStyleStep, textStyleStepsFromSettings, TextStyleStep } from './layerList';
import { usePresentationSettings } from '../PresentationSettingsContext';

interface TextStyleSelectProps {
  object: SlideObject;
  disabled?: boolean;
  fullWidth?: boolean;
  onChange: (step: TextStyleStep) => void;
}

const TextStyleSelect: React.FC<TextStyleSelectProps> = ({ object, disabled, fullWidth, onChange }) => {
  const { settings } = usePresentationSettings();
  const steps = textStyleStepsFromSettings(settings.textStyles.steps);
  const matched = matchTextStyleStep(object.style, object.content, steps);
  return (
    <Select
      size="small"
      displayEmpty
      disabled={disabled}
      title="Textstil"
      value={matched?.id || ''}
      onMouseDown={(event) => event.stopPropagation()}
      onChange={(event) => {
        const step = steps.find((item) => item.id === event.target.value);
        if (step) onChange(step);
      }}
      renderValue={() => matched?.label || 'Textstil'}
      sx={{
        minWidth: fullWidth ? undefined : 168,
        width: fullWidth ? '100%' : undefined,
        flexShrink: 0,
        color: PRES.textPrimary,
        bgcolor: PRES.white,
        borderRadius: 1.5,
        fontFamily: TYPE.ui,
        fontSize: 12,
        '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(10,39,87,0.12)' },
        '& .MuiSelect-select': {
          py: 0.55,
          px: 1.1,
          fontFamily: TYPE.ui,
          fontWeight: 500,
          textTransform: 'none',
        },
      }}
      MenuProps={{
        PaperProps: { sx: { maxHeight: 320 } },
      }}
    >
      <MenuItem value="" sx={{ display: 'none' }} />
      {steps.map((step) => (
        <MenuItem
          key={step.id}
          value={step.id}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
            fontFamily: TYPE.ui,
            fontWeight: 500,
            fontSize: 13,
            color: PRES.textPrimary,
          }}
        >
          <Box component="span">{step.label}</Box>
          <Box
            component="span"
            aria-hidden
            sx={{
              minWidth: 36,
              textAlign: 'right',
              fontFamily: resolveSlideFontFamily(step.fontFamily),
              fontWeight: step.fontWeight,
              fontSize: 16,
              lineHeight: 1,
              textTransform: step.textTransform,
              color: PRES.textSecondary,
            }}
          >
            {step.textTransform === 'uppercase' ? 'AA' : 'Aa'}
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default TextStyleSelect;
